import apis from "../common/apis";
import {
  IEventModel,
  IEventSettingsModel,
  ILuckyWheelSummaryModel,
  IOrderInfoModel,
  IPrizeModel,
  ISpinLuckyWheelModel,
} from "../models/eventModel";
import { HTTP_METHOD_GET, HTTP_METHOD_POST } from "../utils/constant";
import { callApi } from "./fetchTools";

const getEventLuckyWheel = () => {
  return callApi<IEventModel>(HTTP_METHOD_GET, apis.getEventLuckyWheel, null);
};

const getEventSettings = () => {
  return callApi<IEventSettingsModel>(HTTP_METHOD_GET, apis.getEventSettings, null);
}

const getLuckyWheelSummary = (eventId: string, storeCode: string, lastId?: string) => {
  return callApi<ILuckyWheelSummaryModel[]>(
    HTTP_METHOD_GET,
    apis.getEventLuckyWheelSummary.replace(":id", eventId),
    {
      storeCode,
      lastId
    }
  );
};

const validateOrder = (eventId: string, model: ISpinLuckyWheelModel) => {
  return callApi<IOrderInfoModel>(
    HTTP_METHOD_POST,
    apis.postEventValidateOrder.replace(":id", eventId),
    model
  );
};

const getLuckyWheelPrizes = (eventId: string, storeCode: string) => {
  return callApi<IPrizeModel[]>(
    HTTP_METHOD_GET,
    apis.getLuckyWheelPrizes.replace(":id", eventId),
    { store_code: storeCode }
  );
};

const getEventGifts = (eventId: string, storeCode: string) => {
  return callApi<IPrizeModel[]>(
    HTTP_METHOD_GET,
    apis.getLuckyWheelGifts.replace(":id", eventId),
    { store_code: storeCode }
  );
};

const getEventStores = () => {
  return callApi<any>(HTTP_METHOD_GET, apis.getEventStores, null);
};

const spinLuckyWheel = (eventId: string, model: ISpinLuckyWheelModel) => {
  return callApi<ILuckyWheelSummaryModel>(
    HTTP_METHOD_POST,
    apis.postSpinLuckyWheel.replace(":id", eventId),
    model
  );
};

const EventRepositories = {
  getEventSettings,
  validateOrder,
  getEventLuckyWheel,
  getLuckyWheelSummary,
  getLuckyWheelPrizes,
  getEventGifts,
  getEventStores,
  spinLuckyWheel,
};

export default EventRepositories;
